import { Component, OnInit, Inject, ChangeDetectionStrategy, signal } from '@angular/core'
import { FieldTree, form } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { arvonMuutokset } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { NaytettavaJatkuva } from '../tositteet/tosite-kirjaamattomat.component'
import { KirjattavaKuitti, KirjattavaRaahattuTiedosto } from 'app/_jaettu-lemonator/model/kirjanpito'

interface YliajosummaLomake {
  summa: number | null
}

export interface TositeMuokkaaYliajosummaaDialogData {
  naytettavaJatkuva: NaytettavaJatkuva
}

@Component({
  templateUrl: './tosite.muokkaa-yliajosummaa.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TositeMuokkaaYliajosummaaDialog implements OnInit {
  lomake: FieldTree<YliajosummaLomake>

  private _yliajosumma: number
  private _kirjattavaObjekti: KirjattavaKuitti | KirjattavaRaahattuTiedosto

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: TositeMuokkaaYliajosummaaDialogData,
    private _dialogRef: MatDialogRef<TositeMuokkaaYliajosummaaDialog>,
    private _formValidationService: FormValidationService,
  ) {
    this._kirjattavaObjekti = this._data.naytettavaJatkuva.kuitti?.kirjattavaKuitti || this._data.naytettavaJatkuva.raahattava?.raahattava
    const currentYliajosumma = this._kirjattavaObjekti?.a || null
    this.lomake = form(signal<YliajosummaLomake>({ summa: currentYliajosumma }))
    arvonMuutokset(this.lomake.summa).subscribe(value => {
      this._yliajosumma = value
    })
  }

  ngOnInit() {}

  tallenna() {
    if (this.lomake().invalid()) {
      this._formValidationService.merkitseKokoLomakeKosketuksi(this.lomake)
      return
    }
    if (this._yliajosumma === undefined || this._yliajosumma === null) {
      delete this._kirjattavaObjekti.a
    } else {
      this._kirjattavaObjekti.a = this._yliajosumma
    }

    this._dialogRef.close(true)
  }
}
